module.exports = __webpack_public_path__ + "static/media/qr-walink-storefront.ef177506.jpeg";